<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          FAQ
          <el-button class="title_btn" @click="moveCreate()" type="primary">등록</el-button>
        </div>
        <div class="write_tab">
          <div class="write_tab_content active">
            FAQ목록
          </div>
          <div class="write_tab_content" @click="movePage('category')">
            카테고리 관리
          </div>
        </div>
        <div class="list-content">
          <board-list-component :boardType="'faq'"></board-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "Faq",
  mixins: [],
  components: {BoardListComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveCreate() {
      this.$router.replace(this.$route.path);
      this.$router.push(`/faq/create`);
    },
    movePage(data) {
      this.$router.push(`${data}`);
    },
  },
  watch: {},
}
</script>

<style lang="scss">
</style>